



















import Vue, { PropType } from "vue";
import UPDATE_ATTENDANCE_MUTATION from "@/graphql/UpdateAttendanceMutation.gql";
import { RegistrationQuery_registrations } from "@/graphql/generatedTypes/RegistrationQuery";
import {
  UpdateAttendanceMutation,
  UpdateAttendanceMutation_updateAttendance_errors,
  UpdateAttendanceMutationVariables
} from "@/graphql/generatedTypes/UpdateAttendanceMutation";

export default Vue.extend({
  name: "SessionAttendance",
  props: {
    registrations: Array as PropType<RegistrationQuery_registrations[]>,
    name: String
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Attended",
          value: "action",
          sortable: false
        }
      ]
    };
  },
  computed: {
    registrationItems(): { id: string | null; name: string; attended: boolean | null }[] {
      return this.registrations.map(registration => ({
        id: registration.id,
        name: `${registration.user?.firstName} ${registration.user?.lastName}`,
        attended: registration.attended
      }));
    }
  },
  methods: {
    async updateAttendance(item: { id: string | null; name: string; attended: boolean | null }) {
      try {
        if (!item.id) {
          return;
        }

        const result = await this.$apollo.mutate<UpdateAttendanceMutation, UpdateAttendanceMutationVariables>({
          mutation: UPDATE_ATTENDANCE_MUTATION,
          variables: {
            registration_id: item.id,
            attended: !item.attended
          }
        });

        if (result.data?.updateAttendance?.errors) {
          result.data.updateAttendance.errors.forEach((error: UpdateAttendanceMutation_updateAttendance_errors) => {
            this.$alertService.addAlert({ message: error.message, type: "error" });
          });

          return;
        }

        if (result.data?.updateAttendance?.ok) {
          item.attended = !item.attended;
        }
      } catch (e) {
        await this.$alertService.addAlert({ message: "An error has occurred, please try again!", type: "error" });
      }
    }
  }
});
